
<div class="container">
  <header class="page-header-title" i18n>Template overview</header>
  @if (totalCount !== null) {
    <p class="page-sub-header" i18n>
      {totalCount, plural,
        =0 {No templates available}
        =1 {{{totalCount}} template available}
        other {{{totalCount}} templates available}
      }
    </p>
  }

  <div class="content-card-background">
    <div class="header-row">
      <select class="group-dropdown" (change)="onSelectionChange(selectionDropdown.value)" #selectionDropdown>
        <option [value]="null" [selected]="selection$.value === null" i18n>All</option>
        <option [value]="ImageTypeEnum.GIF" [selected]="selection$.value === ImageTypeEnum.GIF" i18n>GIF</option>
        <option [value]="ImageTypeEnum.Video" [selected]="selection$.value === ImageTypeEnum.Video" i18n>Video</option>
        <option [value]="ImageTypeEnum.Image" [selected]="selection$.value === ImageTypeEnum.Image" i18n>Image</option>
      </select>

      <div class="divider"></div>

      <div class="table-header-input-wrapper">
        <input type="text" i18n-placeholder placeholder="Click here to search" [formControl]="search">
        <i class="fas fa-search input-icon"></i>
      </div>

      <div class="dropdown-button-wrapper" registerMenuToggle
        (clickedOutside)="labelControlOpen = false">
        <div class="dropdown-button"
          (click)="openLabelOrTagControl(MultiSelectType.LABEL)">
          <ng-container>labels</ng-container><i class="fa-solid fa-chevron-down"></i>
        </div>

        @if (labelControlOpen) {
          <div class="multi-select-wrapper">
            <app-multi-select
              [checkAllOnEmpty]="true"
              [labels]="labels"
              [showControlButtons]="currentUser?.role === RoleType.ADMIN || currentUser?.role === RoleType.SUPERADMIN"
              [formControl]="labelControl"
              [multiSelectType]="MultiSelectType.LABEL"
            ></app-multi-select>
          </div>
        }
      </div>

      <div class="dropdown-button-wrapper" registerMenuToggle
        (clickedOutside)="tagControlOpen = false">
        <div class="dropdown-button"
          (click)="openLabelOrTagControl(MultiSelectType.TAG)">
          <ng-container>tags</ng-container><i class="fa-solid fa-chevron-down"></i>
        </div>

        @if (tagControlOpen) {
          <div class="multi-select-wrapper">
            <app-multi-select
              [checkAllOnEmpty]="true"
              [tags]="tags"
              [showControlButtons]="currentUser?.role === RoleType.ADMIN || currentUser?.role === RoleType.SUPERADMIN"
              [formControl]="tagControl"
              [multiSelectType]="MultiSelectType.TAG"
            ></app-multi-select>
          </div>
        }
      </div>

      <div class="archived-toggle-wrapper">
        <label class="toggle-switch" for="archived-toggle">
          <input type="checkbox" id="archived-toggle" [checked]="onlyArchived.value === null" (change)="toggleArchived()">
          <span class="slider"></span>
        </label>
        <label for="archived-toggle" i18n>Include archived</label>
      </div>


    </div>

    @if (templates.length === 0 && loading === false) {
      <h4 class="no-templates" i18n>No templates found</h4>
    }

    @for (template of templates; track template.id; let isLast = $last) {
      <div class="row template-row" [class.no-bottom-line]="isLast && pageCount <= 1">
        @if (template.items.length > 1 && template.id !== currentTemplateId) {
          <button (click)="setTemplateId(template.id)"><i class="fas fa-chevron-right dropdown-arrow"></i></button>
        }
        @if (template.items.length > 1 && template.id === currentTemplateId) {
          <button (click)="setTemplateId(template.id)"><i class="fas fa-chevron-down dropdown-arrow"></i></button>
        }
        <a class="template-img-wrapper">
          <img
            class="template-img"
            [class.right]="template.items.length <= 1"
            [class.archived]="template.items[0].archived"
            [src]="template.thumbnail"
            alt="template thumbnail"
            (click)="template.items.length <= 1 ? toTemplateDetails(template.items[0].id) : setTemplateId(template.id)">
            @if (template.items.length >= 1) {
              <div
                class="image-icon-border"
                [class.right]="template.items.length <= 1"
                (click)="template.items.length <= 1 ? toTemplateDetails(template.items[0].id) : setTemplateId(template.id)">
                @if (template.items.length > 1) {
                  <i class="fas fa-layer-group image-icon button-icon"></i>
                }
                @if (template.items.length <= 1) {
                  <div class="more-items">
                    @if (template.items[0].type === ImageTypeEnum.Video) {
                      <i class="fas fa-play-circle image-icon"></i>
                    }
                    @if (template.items[0].type === ImageTypeEnum.Image) {
                      <i class="far fa-image-polaroid image-icon"></i>
                    }
                    @if (template.items[0].type === ImageTypeEnum.GIF) {
                      <img src="assets/icons/gif.svg" class="image-icon" alt="">
                    }
                  </div>
                }
              </div>
            }
          </a>
          <div class="template-details">
            <h2 (click)="template.items.length <= 1 ? toTemplateDetails(template.items[0].id) : setTemplateId(template.id)">{{template.title}}</h2>
            <p class="template-date"> <ng-container i18n>Created on</ng-container> {{ template.created | date }} </p>
            <p class="content-text" [innerHTML]="template.description"></p>
            <div class="template-details-button-wrapper clearfix">
              <section class="counter-labels">
                <div class="content-wrapper" (click)="toContentWithTemplateId(template.id)">
                  <div class="content-icon-background">
                    <i class="far fa-play-circle content-icon"></i>
                  </div>
                  <div class="content-stats">
                    <h6>{{ template.statistics.newContentCount | shortNumber }}</h6>
                    <p i18n>Unique content</p>
                  </div>
                </div>
                <div class="content-wrapper">
                  <div class="content-icon-background">
                    <i class="far fa-eye content-icon"></i>
                  </div>
                  <div class="content-stats">
                    <h6>{{ template.statistics.newViewsCount | shortNumber }}</h6>
                    <p i18n>Views</p>
                  </div>
                </div>
              </section>
              @if (template.items[0]?.builderConfigId) {
                <div class="content-wrapper">
                  <div class="button-wrapper">
                    <button class="skideo-flat-button green img-left rectangular edit-button" [routerLink]="['/templates', TemplateEditMode.EDIT, template.items[0].id]">
                      <img src="assets/icons/arrow-circle-chevron-right.svg" alt="">
                      <span class="button-text" i18n>Edit template</span>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="statistics-button-wrapper">
            <div class="template-statistics-button statistics-button" [routerLink]="['/reports']" [queryParams]="{templateId: template.id}">
              <i class="far fa-chart-line statistics-icon"></i>
            </div>
          </div>
          @if (currentTemplateId === template.id) {
            <div class="template-item-dropdown">
              @for (item of template.items; track item.id) {
                <div class="template-item-dropdown-row clearfix">
                  <div class="template-dropdown-item-left clearfix">
                    <div class="template-item-icon-border" (click)="toTemplateDetails(item.id)">
                      @switch(item.type) {
                        @case (ImageTypeEnum.Video) {
                          <i class="fas fa-play-circle template-item-icon"></i>
                        }
                        @case (ImageTypeEnum.Image) {
                          <i class="far fa-image-polaroid template-item-icon"></i>
                        }
                        @case (ImageTypeEnum.GIF) {
                          <img src="assets/icons/gif.svg" class="template-item-icon" alt="">
                        }
                      }
                    </div>
                    <div class="template-item-details">
                      <div class="clearfix template-item-top-row">
                        <h3 class="template-item-id" (click)="toTemplateDetails(item.id)">{{ item.title }}</h3>
                      </div>
                      <div class="template-item-bottom-row">
                        <p class="template-item-title">{{ template.title }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="template-dropdown-item-right clearfix">
                    <div class="to-content" (click)="toContentWithTemplateItemId(item.id)">
                      <i class="far fa-play-circle created-icon"></i>
                      <div class="created-content">
                        <h4>{{ item.statistics.newContentCount }}</h4>
                        <p i18n>Unique content</p>
                      </div>
                    </div>
                    <div class="to-content">
                      <i class="far fa-eye delivered-icon"></i>
                      <div class="delivered-content">
                        <h4>{{ item.statistics.newViewsCount }}</h4>
                        <p i18n>Views</p>
                      </div>
                    </div>
                    <div class="statistics-button" (click)="toStatisticsWithTemplateItemId(item.id)">
                      <i class="far fa-chart-line statistics-icon"></i>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (pageCount > 1) {
        <div class="footer-pager-row">
          <button (click)="previousPage()" [disabled]="offset.value <= 1" class="skideo-flat-button black img-left">
            <i class="fas fa-arrow-left next-page-button-icon"></i>
            <ng-container i18n>Previous page</ng-container>
          </button>
          <select [formControl]="offset">
            @for (number of pages; track number) {
              <option [ngValue]="number + 1">{{ number + 1 }}</option>
            }
          </select>
          <button (click)="nextPage()" [disabled]="offset.value >= pageCount" class="skideo-flat-button black img-right">
            <ng-container i18n>Next page</ng-container>
            <i class="fas fa-arrow-right next-page-button-icon"></i>
          </button>
        </div>
      }

    </div>
  </div>
